import { RestTypesType } from '@spa/constants/RestTypes'
import type { Moment } from 'moment'
import moment from 'moment'

import { HALF_DAY } from '../components/DayFields/DayFields'

type DateData = {
  start_half_day?: string
  end_half_day?: string
  starts_at?: Date | string | Moment
  ends_at?: Date | string
  time_range?: string[]
}

const getDateWithHalfDay = (data: DateData) => {
  const momentStart = moment(data.starts_at)
    .clone()
    .hours(data.start_half_day === HALF_DAY.AFTERNOON ? 12 : 0)

  const momentEnd = moment(data.ends_at)
    .clone()
    .add(data.end_half_day === HALF_DAY.AFTERNOON ? 1 : 0, 'days')
    .hours(data.end_half_day === HALF_DAY.AFTERNOON ? 0 : 12)

  return { momentStart, momentEnd }
}

export const getFullDate = (data: DateData) => {
  // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
  const [startTime, endTime] = data.time_range
  // as startTime and endTime are strings
  // we need to convert them to numbers
  const [startHour, startMin] = startTime.split(':')
  const startHourNumber = Number(startHour)
  const startMinNumber = Number(startMin)
  const [endHour, endMin] = endTime.split(':')
  const endHourNumber = Number(endHour)
  const endMinNumber = Number(endMin)

  // Handle shift break that occures during night
  // e.g shift from 22:00 to 03:00, shift breaks from 00:30 to 01:00
  const momentStart = moment(data.starts_at)
    .clone()
    .add(moment(data.starts_at).get('hours') > startHourNumber ? 1 : 0, 'days')
    .hours(startHourNumber)
    .minutes(startMinNumber)

  const momentEnd = momentStart
    .clone()
    .add(endHourNumber < startHourNumber ? 1 : 0, 'days')
    .hours(endHourNumber)
    .minutes(endMinNumber)

  return { momentStart, momentEnd }
}

export const getStartAndEndDate = (data: DateData, type: string) => {
  if (type === RestTypesType.DAY) {
    return getDateWithHalfDay(data)
  }

  return getFullDate(data)
}
